export const onfidoFullLegal = `<p class="onfido-full-legal">Voor de tenaamstelling van uw account, gebruiken wij de gegevens zoals op uw identiteitsbewijs</p>`;
